<template>
  <div class="container-full-5">
    <h1 class="secondary-font gap-4 mt-2 mb-2">
      Informations personnelles
    </h1>
    <p class="mb-5 text-grey-600">
      Consultez et modifiez vos informations personnelles.
    </p>

    <div class="info-card">
      <form @submit.prevent="handleSaveInfo">
        <div class="form-row">
          <div class="form-group">
            <label for="nom">Nom</label>
            <input
              id="nom"
              v-model="formData.nom"
              type="text"
              class="form-input"
              placeholder="Votre nom"
            />
          </div>

          <div class="form-group">
            <label for="prenom">Prénom</label>
            <input
              id="prenom"
              v-model="formData.prenom"
              type="text"
              class="form-input"
              placeholder="Votre prénom"
            />
          </div>
        </div>

        <div class="form-group">
          <label for="email">Email</label>
          <input
            id="email"
            v-model="formData.email"
            type="email"
            class="form-input"
            placeholder="votre@email.com"
          />
        </div>

        <div class="form-group">
          <label for="telephone">Téléphone</label>
          <input
            id="telephone"
            v-model="formData.telephone"
            type="tel"
            class="form-input"
            placeholder="+225 XX XX XX XX XX"
          />
        </div>

        <div class="form-group">
          <label for="fonction">Fonction</label>
          <input
            id="fonction"
            v-model="formData.fonction"
            type="text"
            class="form-input"
            placeholder="Votre fonction"
          />
        </div>

        <div v-if="success" class="alert alert-success">
          {{ success }}
        </div>

        <button type="submit" class="btn flex-center gap-2 mt-4">
          <img src="/public/icons/icon-info-perso.svg" alt="" class="btn-icon btn-icon-white" />
          Enregistrer les modifications
        </button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import authService from '@/services/authService'

export default defineComponent({
  name: 'InformationsPersonnelles',
  setup() {
    const formData = ref({
      nom: '',
      prenom: '',
      email: '',
      telephone: '',
      fonction: ''
    })
    const success = ref('')

    onMounted(() => {
      const user = authService.getCurrentUser()
      if (user) {
        formData.value = {
          nom: user.nom || '',
          prenom: user.prenom || '',
          email: user.email || '',
          telephone: user.telephone || '',
          fonction: user.fonction || ''
        }
      }
    })

    const handleSaveInfo = () => {
      // TODO: Appeler l'API pour mettre à jour les informations
      success.value = 'Vos informations ont été mises à jour avec succès !'
      setTimeout(() => {
        success.value = ''
      }, 3000)
    }

    return {
      formData,
      success,
      handleSaveInfo
    }
  }
})
</script>

<style scoped>
.info-card {
  max-width: 700px;
  margin-top: 2rem;
  padding: 2.5rem;
  border-radius: 24px;
  background: white;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(88, 101, 242, 0.08);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgb(34, 34, 34);
  margin-bottom: 0.5rem;
}

.form-input {
  width: 100%;
  padding: 0.9rem 1.2rem;
  border: 2px solid rgba(88, 101, 242, 0.15);
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: rgb(88, 101, 242);
  box-shadow: 0 0 0 4px rgba(88, 101, 242, 0.1);
}

.alert-success {
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  background: rgba(0, 208, 180, 0.1);
  color: rgb(0, 150, 130);
  border: 1px solid rgba(0, 208, 180, 0.3);
}

.btn-icon-white {
  filter: brightness(0) invert(1);
}

@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}
</style>
